import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { ConectarCajaModelEdit, ConectarCajaModel } from "./conectar";
import { DesconectarCajaModal, DesconectarCajaModel } from "./desconectar";
import { AsignarCajaSucursalModal, AsignarCajaSucursalModel } from "./sucursal";


const ConectarButton = kea.defaultProps(kea.Button, { children: "Conectar / asignar", iconClass: fa("plug") });
const DesconectarButton = kea.defaultProps(kea.Button, { children: "Desconectar", iconClass: fa("arrows-h") });
const SucursalButton = kea.defaultProps(kea.Button, { children: "Asignar a sucursal", iconClass: fa("map-marker") });

/**Botones de creacion de movimientos de caja */
export class MovimientoCajaRutaIndex extends React.PureComponent {
    modalManager = kea.createModalManager();

    onConectar = async () => {
        const result = await this.modalManager.showModal(ConectarCajaModelEdit, undefined, {} as ConectarCajaModel);
        if (result.result) {
            const model = result.value;
            const func = model.tipo == "conectar" ? resources.CajaRuta.ConectarCaja : resources.CajaRuta.AsignarCaja;
            await func(model.idCaja, model.idCamion);
        }
    }
    onDesconectar = async () => {
        const result = await this.modalManager.showModal(DesconectarCajaModal, undefined, {} as DesconectarCajaModel);
        if (result.result) {
            const model = result.value;
            await resources.CajaRuta.DesconectarCaja(model.idCaja);
        }
    }

    onAsignarSucursal = async () => {
        const result = await this.modalManager.showModal(AsignarCajaSucursalModal, undefined, {} as AsignarCajaSucursalModel);
        if (result.result) {
            const model = result.value;
            await resources.CajaRuta.AsignarCajaSucursal(model.idCaja, model.idSucursal);
        }
    }

    render() {
        return (
            <div>
                <div className="btn-group" >
                    <ConectarButton onClick={this.onConectar} />
                    <DesconectarButton onClick={this.onDesconectar} />
                    <SucursalButton onClick={this.onAsignarSucursal} />
                </div>

                {this.modalManager.component}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/movimientoscajaruta/edit/index.tsx